import { useEffect, useRef, useState } from 'react'

const FishDivider = () => {
  const [progress, setProgress] = useState(0)
  const lastRippleProgress = useRef(0)
  const requestRef = useRef<number>()
  // Track the last direction (up or down)
  const [lastDirectionUp, setLastDirectionUp] = useState(false)
  const lastScrollY = useRef(window.scrollY)
  // State for the displayed rotation
  const [displayedRotation, setDisplayedRotation] = useState(90)

  useEffect(() => {
    // Immediate direction detection and progress update on scroll
    const handleScroll = () => {
      const scrollY = window.scrollY
      if (scrollY < lastScrollY.current && !lastDirectionUp) {
        setLastDirectionUp(true)
      } else if (scrollY > lastScrollY.current && lastDirectionUp) {
        setLastDirectionUp(false)
      }
      lastScrollY.current = scrollY
      // Update progress immediately
      const start = 0
      const end = 450
      const rawProgress = (scrollY - start) / (end - start)
      const clamped = Math.max(0, Math.min(1, rawProgress))
      setProgress(clamped)
    }
    window.addEventListener('scroll', handleScroll)
    // Set initial progress
    handleScroll()
    return () => window.removeEventListener('scroll', handleScroll)
  }, [lastDirectionUp])

  // Animate the displayed rotation when direction changes
  useEffect(() => {
    // Calculate the new rotation based on the current progress and direction
    let targetRotation = 90 + 20 * progress
    if (lastDirectionUp) {
      targetRotation += 180
    }
    setDisplayedRotation(targetRotation)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lastDirectionUp])

  // Remove the animation frame loop for progress

  // Fish moves from left (0vw) to right (100vw), rotates from -90 to 90deg
  const left = 0 + 100 * progress
  // Base rotation
  let rotate = 90 + 20 * progress
  // If last direction was up, add 180deg for a full spin
  if (lastDirectionUp) {
    rotate += 180
  }
  const visible = progress > 0 && progress < 1

  // Dispatch a ripple event when progress changes by at least 0.08
  useEffect(() => {
    if (!visible) return
    if (Math.abs(progress - lastRippleProgress.current) >= 0.08) {
      lastRippleProgress.current = progress
      // Calculate fish's center position in px
      const x = (window.innerWidth * (left / 100)) + 280/2 // 280 is fish width
      const y = window.innerHeight - 420 + 140 // move fish higher (was -300 + 140)
      const xrand = (Math.random()-1)*50
      const yrand = (Math.random()-0.5)*100
      window.dispatchEvent(new CustomEvent('fish-ripple', { detail: { x: x+xrand, y: y+yrand } }))
    }
  }, [progress, visible, left])

  return visible ? (
    <img
      src="/koi.gif"
      alt="Koi Fish"
      style={{
        position: 'fixed',
        top: 'calc(100vh - 420px)', // move fish higher (was -300px)
        left: `${left}vw`,
        width: '280px',
        height: 'auto',
        zIndex: 30,
        pointerEvents: 'none',
        transform: `rotate(${displayedRotation}deg)`,
        filter: 'drop-shadow(0 4px 12px rgba(56, 106, 139, 0.4))',
        opacity: 1,
        transition: 'filter 0.2s, transform 0.2s cubic-bezier(0.4,0,0.2,1)',
      }}
      draggable={false}
    />
  ) : null
}

export default FishDivider 